<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>
            TITLE.TITLE_MY_INFO
        </h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body container-fluid">
        <div class="media">
            <div class="imgContainer">
                <div class="pointer" (click)="onUploadImage()">
                    <img src='{{AppSettings.StaffImageURL + "?StaffId=" + Model.StaffId + "&" + guid}}' class="align-self-start imgProfile"/>
                </div>               
            </div>
            <div class="media-body ml-3">
                <table class="table table-borderless table-sm">
                    <tr>
                        <td class="font-weight-bold" translate>LBL.USERNAME</td>
                        <td>{{Model.FName}} {{Model.LName}}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold" translate>LBL.DEPARTMENT</td>
                        <td>{{Model.Department}}</td>
                    </tr>
                    <tr>
                        <td class="font-weight-bold" translate>LBL.DESIGNATION</td>
                        <td>{{Model.Designation}}</td>
                    </tr>
                </table>
               
            </div>

        </div>
        
        <div class="font-weight-bold mt-4" translate>LBL.COMMUNICATION_DEVICES</div>
        <div class="row no-gutters" *ngIf="DeviceList && DeviceList.length == 0" translate>LBL.NO_DEVICE</div>
        <table class="table table-sm  border border-top-0" *ngIf="DeviceList && DeviceList.length > 0">
            <tr>
                <td class="text-muted" translate>LBL.DEVICE_TYPE</td>
                <td class="text-muted text-center" translate>LBL.DEVICE_NUMBER</td>
                <td class="text-muted text-center" translate>LBL.IS_ENABLED</td>
            </tr>
            <tr *ngFor="let row of DeviceList">
                <td class="grdCol">{{row.DeviceName}}</td>
                <td class="grdCol text-center">{{row.DeviceNumber}}</td>
                <td class="grdCol text-center">
                    <span *ngIf="row.IsEnabled" title="{{'TITLE.TITLE_ENABLED' | translate}}"><i class="fas fa-check fa-fw"></i></span>
                </td>
            </tr>
        </table>
    </div>
    <div class="modal-footer justify-content-between">
        <div class="form-check">
            <label class="form-check-label">
                <input type="checkbox" class="form-check-input" [(ngModel)]="Model.IsAlertPopupAudioEnabled" (change)="onNotificationSound($event)">{{'LBL.ALERT_NOTIFICATION_SOUND' | translate}}
            </label>
        </div>
        <button type="button" class="btn btn-primary" (click)="DisableModalOpenEvent = false;c('close')" translate>BTN.BTN_CLOSE</button>
    </div>

</ng-template>

<UploadImage #uploadImage></UploadImage>
